import { theme as oldTheme, Section } from "@nested/nested-react-components";
import { ThemeProvider } from "styled-components";

import { StyledHero } from "../../components/StyledHero/StyledHero";
import { HeroTitle } from "../../components/HeroTitle/HeroTitle";
import { HeroSubtitle } from "../../components/HeroSubtitle/HeroSubtitle";
import { ResearchCard } from "./components/ResearchCard";

const ResearchPage = () => (
  <ThemeProvider theme={oldTheme}>
    <>
      <StyledHero>
        <HeroTitle>Research</HeroTitle>
        <HeroSubtitle>
          Nested&apos;s research on topics in the property industry.
        </HeroSubtitle>
      </StyledHero>
      <Section align="initial" shouldWrap row>
        <ResearchCard
          title="Airbnb"
          summary="Rental affordability in the UK and around the world."
          color="#FF5A59"
          textColor="white"
          to="/research/airbnb/2017/uk/london"
        />
        <ResearchCard
          title="Rental index"
          color="#9df6df"
          summary="Return on investment for Airbnb vs. traditional rental"
          to="/research/rental/2017/uk/london"
        />
      </Section>
    </>
  </ThemeProvider>
);

export { ResearchPage };

export const UniversalRender = ResearchPage;
